export const Aggregators = {
    radiomax: 'RadioMAX',
    radiofx: 'RadioFX',
    singleAndMultiStation: 'Single & Multi-station apps',
}; 